import { getLmsCohortNearest } from '@landing-blocks/shared/utils/get-cohort-date/get-cohort-date.js';
import { useEffect, useState } from 'preact/hooks';

import { COUNTRIES } from '../../constants/countries.js';
import { adaptCohortDateToLead } from './adapt-cohort-date-to-lead.js';

export interface CohortData {
    cohortDate: string | null;
    isLoading: boolean;
}

export const useCohortDate = (countrySlug: string, professionSlug: string) => {
    const [cohortDate, setCohortDate] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if (!countrySlug || !professionSlug) return;

            try {
                setIsLoading(true);

                const { locale, backendLanguage } = COUNTRIES[countrySlug as keyof typeof COUNTRIES];
                const cohortDateString = await getLmsCohortNearest(professionSlug, backendLanguage);

                if (cohortDateString) {
                    const cohortDate = adaptCohortDateToLead(new Date(cohortDateString));
                    const formattedDate = cohortDate.toLocaleString(locale, { month: 'long', day: 'numeric' });

                    setCohortDate(formattedDate);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { cohortDate, isLoading };
};
